import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import ContactsCache, {
  type ContactCustomPropertyInfo,
  isGroupsContactCustomPropertyInfo,
} from 'donor-elf-web/services/contacts-cache';

interface ComponentArgs {
  propertyInfo: ContactCustomPropertyInfo;
  onClose: () => void;
}

export interface OptionAndCount {
  option: string;
  count: number;
}

export default class ContactDetailsPropertiesCustomPropertyEditOptionsModalIndexComponent extends Component<ComponentArgs> {
  @service declare contactsCache: ContactsCache;

  @tracked stage: 'showOptions' | 'reorder' | 'rename' | 'merge' | 'delete' =
    'showOptions';
  @tracked selectedOptionAndCount?: OptionAndCount;

  get isGroupsProperty() {
    return isGroupsContactCustomPropertyInfo(this.args.propertyInfo);
  }

  @action
  showOptions() {
    this.stage = 'showOptions';
  }

  @action
  handleReorderOptions() {
    this.stage = 'reorder';
  }

  @action
  handleRenameOption(optionAndCount: OptionAndCount) {
    this.selectedOptionAndCount = optionAndCount;
    this.stage = 'rename';
  }

  @action
  handleMergeOption(optionAndCount: OptionAndCount) {
    this.selectedOptionAndCount = optionAndCount;
    this.stage = 'merge';
  }

  @action
  handleDeleteOption(optionAndCount: OptionAndCount) {
    this.selectedOptionAndCount = optionAndCount;
    this.stage = 'delete';
  }
}
